import { render, staticRenderFns } from "./dyrsButton.vue?vue&type=template&id=10e9378e"
import script from "./dyrsButton.vue?vue&type=script&lang=js"
export * from "./dyrsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports